import { __decorate, __metadata } from "tslib";
import { AppRequest, HttpGETRequestProperty } from '@core/shared/app-request';
import { Expose, Model, ModelId } from '@core/shared/model';
import { AppRequestMethod } from '@core/shared/request';
let SetReadStateRequest = /*#__PURE__*/(() => {
  let SetReadStateRequest = class SetReadStateRequest extends Model {};
  __decorate([Expose(), HttpGETRequestProperty('number'), __metadata("design:type", Number)], SetReadStateRequest.prototype, "id", void 0);
  __decorate([Expose(), HttpGETRequestProperty('boolean'), __metadata("design:type", Boolean)], SetReadStateRequest.prototype, "read", void 0);
  SetReadStateRequest = __decorate([AppRequest('notifications', 'set-read-state', {
    httpMethod: AppRequestMethod.POST,
    requiredAccessData: ['userId']
  }), ModelId("SetReadStateRequest") // auto-generated by generate-model-ids
  ], SetReadStateRequest);
  return SetReadStateRequest;
})();
export { SetReadStateRequest };